module.exports = __webpack_public_path__ + "static/studio-2a56dcca5fea25049d399fe1a0a9c790.jpg";